<template>
  <!-- eslint-disable max-len -->
  <div>
    <!-- header -->
    <v-container>
      <v-row class="mb-12 mt-12">
        <v-col>
          <div>
            <p class="display-1 font-weight-light primary--text">Nominate your feedback providers</p>
          </div>

          <!-- title section -->
          <div>
            <p class="headline">
              <span>
                Please select seniors, peers and juniors to provide feedback on you.  5+ invites for each group is recommended, but you must invite at least 3 in each group (i.e. at least 3 seniors, 3 peers and 3 juniors).
              </span>
            </p>
            <p class="headline">
              <span>
                For your self-assessment to be recorded, it is compulsory to nominate these reviewers.
              </span>
            </p>
          </div>
        </v-col>
      </v-row>

    </v-container>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Nominate',

  data() {
    return {};
  },

  computed: {
    ...mapGetters([
      'currentStep',
      'surveyFlow',
    ]),
    params() {
      return this.$store.state.params;
    },
  },

};
</script>

<style scoped>

  .submit {
    margin-bottom: 5px;
    border-color: #7823dc;
    color: white !important;
  }

</style>
